module.exports = __webpack_public_path__ + "images/22_950f2a684d6cbac08e442bd3c6d4ae86.jpg";